export const CIEM_EVENTS_TABLE = 'ciem-events-table';
